import { styled } from 'styled-components';
import { IConfigGeneral } from '../../../types/config';

const Styles = styled.div<{
  config: IConfigGeneral;
}>`
  margin: ${({ config: { content } }) => content.h2.margin};
  ul,
  ul ul,
  ul ul ul {
    list-style-type: disc;
  }
  ul li,
  ul ul li,
  ul ul ul li {
    margin-top: 0.8rem;
  }
  .tableOfContentsHeader {
    display: block;
    font-family: ${({ config: { content } }) => content.h3.fontFamily};
    font-weight: ${({ config: { content } }) => content.h3.fontWeight};
    font-size: ${({ config: { content } }) => content.h3.fontSize};
    line-height: ${({ config: { content } }) => content.h3.lineHeight};
    color: ${({ config: { content } }) => content.h3.color};
    margin: ${({ config: { content } }) => content.h3.margin};
    font-style: ${({ config: { content } }) => content.h3.fontStyle};
  }
`;

export default Styles;
